import { styled, Typography } from '@material-ui/core';

type ChatMessageLocationProps = {
  latitude: number;
  longitude: number;
  locationName?: string;
  address?: string;
  width?: number;
  height?: number;
};

const ChatMessageLocation: React.FC<ChatMessageLocationProps> = ({
  latitude,
  longitude,
  locationName,
  address,
  width = 320,
  height = 'auto',
}) => {
  const openLocation = () => {
    window.open(`http://www.google.com/maps/place/${latitude},${longitude}`);
  };

  return (
    <ChatMessageLocationStyled onClick={openLocation} style={{ width, height }}>
      <img
        src="/images/location.png"
        alt=""
        style={{ width: 'inherit', height: 'inherit' }}
      />
      {locationName && (
        <Typography variant="subtitle1">{locationName}</Typography>
      )}
      {address && <Typography variant="subtitle2">{address}</Typography>}
    </ChatMessageLocationStyled>
  );
};

const ChatMessageLocationStyled = styled('div')({
  cursor: 'pointer',
  margin: 'auto',
  height: 180,
  '& > div': {
    height: 'auto !important',
    width: 'auto !important',
  },
  '& .gm-fullscreen-control': {
    display: 'none',
  },
  '& .gm-style-cc': {
    display: 'none',
  },
  '& .gmnoprint': {
    display: 'none',
  },
});

export default ChatMessageLocation;
